module.exports = __webpack_public_path__ + "static/img/7c.7bdc0e7.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/art/7c.jpg
// module id = CiD4
// module chunks = 0